module.exports = require("wix-window");